import dayjs from 'dayjs';

import { SupportRequestRow, SupportReplacementRow } from 'store/api/support';

// The exact texts of BUILD-SPEC §6.5 (and the Zelle/check one, REV16 r6).
export const UNRESOLVED_CARD_TEXT =
  'Customer care refund unresolved: the card may already be refunded. Do NOT refund it again in POS.';
// Review M1 (27 Oct): Clover showed no refund at all, so the strip says to
// wait for POS's 24 h check instead of "do not refund".
export const NO_REFUND_SEEN_TEXT =
  "Customer care refund not confirmed: Clover shows no refund for it yet. POS checks again a day later; don't refund it in POS before then.";
export const UNRESOLVED_PAYBACK_TEXT =
  "Customer care Zelle/check pay-back not confirmed: check this receipt's refunds before recording it again.";

/** "Refunded by Customer care (Ana M.) · ticket K3J9X2PQA" */
export const refundedText = (request: SupportRequestRow) =>
  [
    `Refunded by Customer care${request.requestedBy ? ` (${request.requestedBy})` : ''}`,
    request.supportTicketId ? `ticket ${request.supportTicketId}` : null,
  ]
    .filter(Boolean)
    .join(' · ');

export const unresolvedText = (request: SupportRequestRow) => {
  if (request.paymentMethod !== 'card') {
    return UNRESOLVED_PAYBACK_TEXT;
  }
  return request.noRefundSeen ? NO_REFUND_SEEN_TEXT : UNRESOLVED_CARD_TEXT;
};

const shortDay = (value: string) => dayjs(value).format('D MMM');

/** "Customer care sent a replacement: 1 × Belt · shipped UPS 1Z… · delivered 22 Oct" */
export const replacementText = (replacement: SupportReplacementRow) => {
  const items = replacement.items
    .map((item) => `${item.quantity} × ${item.name ?? 'item'}`)
    .join(', ');
  const shipped =
    replacement.trackingNumber || replacement.shippedAt
      ? ['shipped', replacement.carrier, replacement.trackingNumber]
          .filter(Boolean)
          .join(' ')
      : replacement.status === 'approved'
        ? 'approved, not shipped yet'
        : replacement.status.replace(/_/g, ' ');
  return [
    `Customer care sent a replacement: ${items}`,
    shipped,
    replacement.deliveredAt
      ? `delivered ${shortDay(replacement.deliveredAt)}`
      : null,
    replacement.status === 'returned' ? 'returned to sender' : null,
  ]
    .filter(Boolean)
    .join(' · ');
};
